<template>
  <vs-table hover-flat v-if="ringGroups && ringGroups.length" :data="ringGroups" class="table-configuration-inbound-ring-group-list">
    <template slot="thead">
      <vs-th v-text="$t('ring_group.table.no')"></vs-th>
      <vs-th v-text="$t('ring_group.table.ring_group')"></vs-th>
      <vs-th v-text="$t('ring_group.table.ring_name')"></vs-th>
      <vs-th class="text-center" v-text="$t('ring_group.table.action')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('ring_group.table.no')"></vs-td>
        <vs-td :data-tr-title="$t('ring_group.table.ring_group')">
          <vs-input :placeholder="$t('ring_group.table.ring_group')" v-model="tr.group" class="w-full" v-if="tr.edit == true"/>
          <validation-error :model-error="tr.ringGroupFormErrors.group"></validation-error>
          <badge-clipboard :text="tr.group" v-if="tr.edit == false"></badge-clipboard>
        </vs-td>
        <vs-td :data-tr-title="$t('ring_group.table.ring_name')">
          <vs-input :placeholder="$t('ring_group.table.ring_name')" v-model="tr.name" class="w-full" v-if="tr.edit == true"/>
          <validation-error :model-error="tr.ringGroupFormErrors.name"></validation-error>
          <span v-if="tr.edit == false">{{ tr.name }}</span>
        </vs-td>
        <vs-td>
          <div class="flex justify-center">
            <template v-if="tr.edit == true">
              <save-button @click="$emit('customClickSave', indextr, tr.id)" :id="'updateConfigurationRingGroupsButton' + tr.id"></save-button>&nbsp;
              <cancel-button @click="$emit('customClickCancel', indextr, tr.id)"></cancel-button>
            </template>
            <template v-if="tr.edit == false">
              <edit-button @click="$emit('customClickEdit', indextr, tr.id)"></edit-button>&nbsp;
              <delete-button @click="$emit('customClickDelete', indextr, tr.id)"></delete-button>
            </template>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
export default {
  name: 'Shared.Configuration.Inbound.RingGroups.List',
  props: {
    ringGroups: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style lang="scss">
  .table-configuration-inbound-ring-group-list {
    tr {
      th {
        &:nth-child(1) { width: 5%; }
        &:nth-child(2) { width: 20%; }
        &:nth-child(3) { width: 60%; }
        &:nth-child(4) { width: 15%; }
      }

      th,
      td {
        vertical-align: middle;
      }
    }
  }
</style>
